import { createSlice } from '@reduxjs/toolkit';

/**
 * @typedef {Object} Alert
 * @property {string} message - The message of the alert.
 * @property {string} title - The title of the alert.
 * @property {string} variant - The variant of the alert (danger, warning, success).
 */

const alertSlice = createSlice({
  name: 'alertSlice',
  initialState: {
    alert: /** @type {Alert} */ (null),
    show: false,
  },
  reducers: {
    alert: (state, action) => {
      state.alert = action.payload;
      state.show = true;

      // If a timeout parameter is provided, set a timeout to dismiss the alert
      if (action.payload.timeout) {
        setTimeout(() => {
          state.alert = null;
          state.show = false;
        }, action.payload.timeout);
      }
    },
    dismissAlert: (state) => {
      state.alert = null;
      state.show = false;
    },
  },
});

export const {
  alert,
  dismissAlert,
} = alertSlice.actions;

export default alertSlice.reducer;
